import { render, staticRenderFns } from "./SubstrForm.vue?vue&type=template&id=1bc1e5f2&scoped=true&"
import script from "./SubstrForm.vue?vue&type=script&lang=js&"
export * from "./SubstrForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bc1e5f2",
  null
  
)

export default component.exports